// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 688 ? "a1ffd009" : chunkId) + "." + {"688":"05b8605d72fbb6cf","5708":"aaba458962f4f282"}[chunkId] + ".js";
};